var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client)?_c('div',[_vm._v(" DevOps mode "),_c('el-switch',{attrs:{"inactive-color":"#f0f0f0","active-color":"#ff4949","value":_vm.devops,"disabled":!_vm.client.team},on:{"change":_vm.change}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }